/* eslint-disable max-len */
export default [
  {
    title: 'Pro Desk - Expert Support for Pros',
    description: 'Get personalized service, special orders, and bulk pricing at The Home Depot\'s Pro Desk. Save time and streamline your projects with expert assistance.',
    ctaUrl: '/c/pro-desk',
    imageUrl: 'https://dam.thdstatic.com/content/production/WIznKPTz7MplgGqXkRuO2Q/7PhQh-19dUotrNIi3zhVtw/3:2%20Pro%20Desk%20PPS/100_2022_ePro_PASAs_L4887_32%20Pro%20Desk%20PPS.jpg?im=Resize=(400)'
  },
  {
    title: 'Pro Services & Contractor Support',
    description: 'Unlock exclusive perks, bulk pricing, and business tools with The Home Depot\'s Pro Services. Optimize your workflow and maximize savings with Pro Xtra.',
    ctaUrl: '/c/pro',
    imageUrl: 'https://dam.thdstatic.com/content/production/BDyqNI-RR2ob_M3SHhDCmQ/LtV19ChL8FvB8L0aKDO-fw/3:2%20Pro%20Desk%20PPS/PX1021-2179_32%20Pro%20Desk%20PPS.jpg?im=Resize=(400)'
  },
  {
    title: 'Special Orders for Pros',
    description: 'Source the materials you need with The Home Depot\'s Special Orders. Get custom quotes, bulk pricing, and job site delivery through the Pro Desk.',
    ctaUrl: '/c/pro-special-order',
    imageUrl: 'https://dam.thdstatic.com/contentful/heroflattenimage/specialorder-hero.jpg?im=Resize=(400)'
  },
  {
    title: 'Pro Services FAQ',
    description: 'Find quick answers about Pro benefits, account management, and exclusive services designed to support your business at The Home Depot.',
    ctaUrl: '/c/pro-faq',
    imageUrl: 'https://dam.thdstatic.com/content/production/-Ew8JGmd0xDFTrkwdsespw/D5EeTUl-azqaPQ6pbSCOLQ/3:2%20PPS%20Pro%20Desk/2023_ProCustom_Investor_Par_Kitchen_0136_v1_32%20PPS%20Pro%20Desk.jpg?im=Resize=(400)'
  }
];